import { render, staticRenderFns } from "./ProjectManage.vue?vue&type=template&id=3a3430f3&scoped=true&"
import script from "./ProjectManage.vue?vue&type=script&lang=ts&"
export * from "./ProjectManage.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectManage.vue?vue&type=style&index=0&id=3a3430f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3430f3",
  null
  
)

export default component.exports